import { Component } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { Observable, map } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent {
	title = 'SkillsTale Identity Services';
	
	ready$ = new Observable<boolean>();
	
	constructor(
		private readonly _route: ActivatedRoute,
		private readonly _translateService: TranslocoService
	) {
		this.ready$ = this._route.queryParamMap.pipe(
			map((params: ParamMap) => {
				const lang = params.get("lang");
				if (lang && this._translateService.isLang(lang)) {
					this._translateService.setActiveLang(lang);
				}
				return true;
			})
		);
	}

}
